/* eslint-disable react/no-unescaped-entities */
import React, { FC } from 'react'
import { Link } from 'react-router-dom'

import { Heading, Hero, Page, Text } from '../components'

export const TermsAndConditionsPage: FC = () => (
  <Page wordyPage>
    <Hero mb="6" showAboutSection={false} />
    <Heading as="h1" mb="4">
      Terms and Conditions
    </Heading>
    <Text mb="3">
      This is a legal agreement (“Agreement”) between you and Caldera, LLC.
      (“Company,” “Service,” “we,” “us,” or “our”). By using our website,
      located at https://www.wavesnippets.com (“Website”), our mobile app,
      and/or other services we provide (collectively, “Wave Snippets”), or
      otherwise accessing the pages of Wave Snippets, you become a user and
      agree to, and are bound by, the terms and conditions of this Agreement for
      as long as you continue to use the Site or Services. IF YOU DO NOT AGREE
      TO BE BOUND BY THIS AGREEMENT, DO NOT USE THE SITE OR THE SERVICES. Your
      use of, or participation in, certain Services may be subject to additional
      terms, and such terms will be either listed in this Agreement or will be
      presented to you for your acceptance when you sign up to use such
      Services.
    </Text>
    <Text mb="3">
      The Wave Snippets services consist of a service to help people create
      animated snippets of your code to share with the world. This includes the
      ability to create snippets, embed them, export them in various formats,
      and display a gallery of them. Wave Snippets is a community that may offer
      additional functionality in regards to exporting animations in the future.
    </Text>
    <Text mb="3">
      This Agreement is subject to change by Wave Snippets in its sole
      discretion at any time, with or without notice. Your continued use of this
      Site or the Services after the posting of revisions to this Agreement will
      constitute your acceptance of such revisions. Please consult the end of
      this Agreement to determine when the Agreement was last revised.
    </Text>
    <Heading mb="4">Ownership of the System and Access License</Heading>
    <Text mb="3">
      You understand and agree that Wave Snippets owns, or (where required,
      appropriate, or applicable) has been licensed by third parties to use, all
      right, title, and interest in and to the System and the Services, and all
      information, text, data, computer code, music, artwork, databases,
      graphics, images, sound recordings, audio and visual clips, logos,
      software, and other materials contained therein, and the compilation,
      collection, design, selection, and arrangement thereof (collectively, the
      "Content"), as well as the design, structure, selection, coordination,
      expression, "look and feel," and arrangement of such Content.
    </Text>
    <Text mb="3">
      You acknowledge that the System and the Services are proprietary to Wave
      Snippets and are protected by applicable intellectual property and other
      proprietary rights, laws, and treaties of the United States and other
      countries, and that you acquire no ownership interest in the System or the
      Services by accessing and using either. For the avoidance of doubt,
      "Content" does not include any Third Party Materials (as defined below) or
      any features, opportunities, or services made available through third
      party websites.
    </Text>
    <Text mb="3">
      Wave Snippets grants you a personal, non-exclusive, non-transferable,
      revocable, limited license to use the System and the Services solely for
      your personal use and subject to the condition that you do not (and do not
      allow any third party to) copy, modify, create a derivative work from,
      reverse engineer, reverse assemble, or otherwise attempt to discover any
      source code, sell, assign, sublicense, grant a security interest in, or
      otherwise transfer any right in or access to the System, the Services, or
      any other Content available via the System or the Services. All rights not
      expressly granted to you in these Terms of Use are reserved and retained
      by Wave Snippets.
    </Text>
    <Heading mb="4">Privacy Policy</Heading>
    <Text mb="3">
      You agree to review the website Privacy Policy posted on this Site, which
      can be accessed here: <Link to="/privacy-policy">Privacy Policy</Link>
    </Text>
    <Heading mb="4">Use of the System and Services</Heading>
    <Text mb="3">
      Wave Snippets reserves the right to do any of the following at any time
      without notice: (i) modify, suspend, or terminate operation of or access
      to the System, the Services, or any portion thereof, for any reason; (ii)
      modify or change the System, the Services, or any portion thereof, and any
      applicable policies or terms; and (iii) interrupt the operation of the
      System, the Services, or any portion thereof, as necessary to perform
      routine or non-routine maintenance, perform error correction, or make
      other changes.
    </Text>
    <Text mb="3">
      You represent and agree that all information that you provide to Wave
      Snippets in connection with your access to and use of the System and the
      Services is and shall be true, accurate, and complete, to the best of your
      knowledge, ability, and belief.
    </Text>
    <Text mb="3">
      Any use or attempted use of the System and/or the Services (i) for any
      unlawful, unauthorized, fraudulent or malicious purpose; (ii) that could
      damage, disable, overburden, or impair any server, or the network(s)
      connected to any server; (iii) that could interfere with any other party's
      use and enjoyment of the System or the Services; (iv) to gain unauthorized
      access to any other accounts, computer systems or networks connected to
      any server or systems through hacking, password mining or any other means;
      (v) to access systems, data or information not intended by Wave Snippets
      to be made accessible to a user; (vi) to attempt to obtain any materials
      or information through any means not intentionally made available by us;
      or (vii) for any use other than the purpose for which it was intended, is
      prohibited.
    </Text>
    <Text mb="3">
      In addition, in connection with your use of the System and the Services,
      you agree you will not:
    </Text>
    <ul>
      <li>
        Upload or transmit any message, information, data, text, software or
        images, or other content that is unlawful, immoral, harmful,
        threatening, abusive, harassing, tortious, defamatory, vulgar, obscene,
        libelous, or otherwise objectionable, or that may invade another's right
        of privacy or publicity;
      </li>
      <li>Use the System or the Services for any criminal purposes;</li>
      <li>
        Create a false identity for the purpose of misleading others or
        impersonate any person or entity, including, without limitation, any
        Wave Snippets representative, or falsely state or otherwise misrepresent
        your affiliation with a person or entity;
      </li>
      <li>
        Upload, email, files that contain viruses, Trojan horses, worms, time
        bombs, cancel-bots, corrupted files, or any other similar software or
        programs that may damage the operation of another's computer or property
        of another;
      </li>
      <li>
        Delete any author attributions, legal notices or proprietary
        designations or labels that you upload to any communication feature;
      </li>
      <li>
        Use any of the System's or Services' communication features in a manner
        that adversely affects the availability of its resources to other users
        caps, or flooding continuous posting of repetitive text);
      </li>
      <li>
        Register, subscribe, attempt to register, attempt to subscribe,
        unsubscribe, or attempt to unsubscribe, any party for any products or
        services if you are not expressly authorized by such party to do so;
      </li>
      <li>
        Harvest or otherwise collect information about others, including e-mail
        addresses; (o) Use any modified versions of the System or the Services,
        for any reason whatsoever, without the express written consent of Wave
        Snippets;
      </li>
      <li>
        Attempt to gain any unauthorized access to the System, the Services or
        any of its associated Content, including computer systems, software, or
        networks; or
      </li>
      <li>
        Use any robot, spider, scraper, or other automated or manual means to
        access the System or the Services, or copy any Content or information
        thereon.
      </li>
    </ul>
    <Text mb="3">
      Wave Snippets reserves the right to take whatever lawful actions it may
      deem appropriate in response to actual or suspected violations of these
      Terms of Use, including, without limitation, the suspension or termination
      of your access and/or account. Wave Snippets may cooperate with legal
      authorities and/or third parties in the investigation of any suspected or
      alleged crime or civil wrong. Except as may be expressly limited by the
      Privacy Policy, Wave Snippets reserves the right at all times to disclose
      any information as Wave Snippets deems necessary to satisfy any applicable
      law, regulation, legal process or governmental request, or to edit, refuse
      to post or to remove any information or materials, in whole or in part, in
      Wave Snippets's sole discretion. You also agree to reimburse Wave Snippets
      for any damage, loss, cost or expense Wave Snippets incurs (including fees
      or costs of attorneys, accountants, professional advisors, and other
      experts incurred in connection with the defense or settlement of the
      foregoing) because of your use of the System or the Services for any
      unlawful or prohibited purpose.
    </Text>
    <Heading mb="4">Accounts, Passwords, and Security</Heading>
    <Text mb="3">
      In order to utilize certain Services, you may need to set up an account
      (including establishing a login ID and password). You are entirely
      responsible for maintaining the confidentiality of your account
      information, including your login ID and password, and for any and all
      activity that occurs under your account or login ID. You agree to notify
      Wave Snippets immediately upon learning of any unauthorized use of your
      account, login ID, or password or any other unauthorized access or breach
      of security. However, you may be held liable for losses incurred by Wave
      Snippets or any other person or entity due to another person using your
      account, login ID, or password.
    </Text>
    <Text mb="3">
      You may not use any other user's account, login ID, or password at any
      time without the express permission and consent of the holder of that
      account, login ID, or password. You may not transfer or assign your
      account.
    </Text>
    <Text mb="3">
      Wave Snippets cannot and will not be liable for any loss or damage arising
      from your failure to comply with these obligations. We reserve the right
      to suspend or terminate your account in the event that you breach any of
      these Terms of Use.
    </Text>
    <Heading mb="4">Submissions</Heading>
    <Text mb="3">
      Any information, communications, or material of any type or nature that
      you submit to or post on the System (or to any of our pages on a social
      media platform or other website) by e-mail, posting, messaging, uploading,
      downloading, or otherwise (collectively, a "Submission") is done at your
      own risk and without any expectation of privacy. Wave Snippets does not
      own any Submissions provided via the System. You are fully responsible for
      all Submissions, which must comply with these Terms of Use. You hereby
      agree that by inputting/submitting such Submissions, you grant Wave
      Snippets a nonexclusive, unrestricted, irrevocable, worldwide,
      sublicenseable, transferable, perpetual, unlimited, assignable, fully paid
      up and royalty-free right to copy, display, edit, publish, prepare
      derivative works of, distribute, process, analyze, use and commercialize,
      in any media known or hereinafter developed, such Submissions (or any
      content or materials contained therein). You hereby represent and warrant
      that you have the full legal right to so use such Submissions and that
      they, and any content or material contained therein, are not confidential
      or proprietary to any third party, nor are you using it in violation of
      any law or contractual restriction.
    </Text>
    <Text mb="3">
      Wave Snippets neither actively monitors general use of the System, nor
      exercises editorial control over any Submissions. However, Wave Snippets
      does reserve the right to monitor such Submissions or other use at any
      time as it deems appropriate and to remove any materials that, in Wave
      Snippets's sole discretion, may be illegal, may subject Wave Snippets to
      liability, may violate these Terms of Use, or are, in the sole discretion
      of Wave Snippets, inconsistent with Wave Snippets's purpose for the
      System.
    </Text>
    <Heading mb="4">Disclaimer of Warranty</Heading>
    <Text mb="3">
      1. No Warranties. THIS SECTION WILL APPLY TO THE MAXIMUM EXTENT PERMITTED
      BY APPLICABLE LAW. WAVE SNIPPETS PROVIDES THE SERVICES ON AN “AS IS” AND
      “AS AVAILABLE” BASIS AND GRANTS NO WARRANTIES OF ANY KIND, WHETHER
      EXPRESS, IMPLIED, STATUTORY OR OTHERWISE WITH RESPECT TO THE SERVICES OR
      THE SITE (INCLUDING ALL INFORMATION CONTAINED THEREIN), INCLUDING ANY
      IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
      NON-INFRINGEMENT. WAVE SNIPPETS DOES NOT WARRANT THAT YOUR USE OF THE
      SERVICES WILL BE SECURE, UNINTERRUPTED, ALWAYS AVAILABLE, ERROR-FREE OR
      WILL MEET YOUR REQUIREMENTS, OR THAT ANY DEFECTS IN THE SERVICES WILL BE
      CORRECTED. WAVE SNIPPETS DISCLAIMS LIABILITY FOR, AND NO WARRANTY IS MADE
      WITH RESPECT TO, THE CONNECTIVITY AND AVAILABILITY OF THE SERVICES.
    </Text>
    <Text mb="3">
      2. Third Party Content. Opinions, advice, statements, offers, or other
      information or content made available through the Services, but not
      directly by WAVE SNIPPETS, are those of their respective authors, and
      should not necessarily be relied upon. Such authors are solely responsible
      for such content. WAVE SNIPPETS DOES NOT: (i) GUARANTEE THE ACCURACY,
      COMPLETENESS OR USEFULNESS OF ANY INFORMATION PROVIDED ON THE SERVICES, OR
      (ii) ADOPT, ENDORSE OR ACCEPT RESPONSIBILITY FOR THE ACCURACY OR
      RELIABILITY OF ANY OPINION, ADVICE, OR STATEMENT MADE BY ANY PARTY OTHER
      THAN WAVE SNIPPETS. UNDER NO CIRCUMSTANCES WILL WAVE SNIPPETS BE
      RESPONSIBLE FOR ANY LOSS OR DAMAGE RESULTING FROM ANYONE’S RELIANCE ON
      INFORMATION OR OTHER CONTENT POSTED ON THE SERVICES, OR TRANSMITTED TO OR
      BY ANY USERS.
    </Text>
    <Text mb="3">
      3. Beta Features. From time to time, Wave Snippets may offer new “beta”
      features or tools with which its users may experiment on the Services.
      Such features or tools are offered solely for experimental purposes and
      without any warranty of any kind, and may be modified or discontinued at
      Wave Snippets’s sole discretion. The provisions of this Disclaimer of
      Warranty section apply with full force to such features or tools.
    </Text>
    <Heading mb="4">Limitation of Liability</Heading>
    <Text mb="3">
      1. Incidental Damages and Aggregate Liability. IN NO EVENT WILL WAVE
      SNIPPETS BE LIABLE FOR ANY INCIDENTAL, SPECIAL, CONSEQUENTIAL OR INDIRECT
      DAMAGES ARISING OUT OF OR RELATING TO THE USE OR INABILITY TO USE THE
      SERVICES, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OR CORRUPTION OF
      DATA OR PROGRAMS, SERVICE INTERRUPTIONS AND PROCUREMENT OF SUBSTITUTE
      SERVICES, EVEN IF Wave Snippets KNOWS OR HAS BEEN ADVISED OF THE
      POSSIBILITY OF SUCH DAMAGES.
    </Text>
    <Text mb="3">
      2. No Liability for non-Wave Snippets Actions. TO THE MAXIMUM EXTENT
      PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL WAVE SNIPPETS BE LIABLE FOR
      ANY DAMAGES WHATSOEVER, WHETHER DIRECT, INDIRECT, GENERAL, SPECIAL,
      COMPENSATORY, CONSEQUENTIAL, AND/OR INCIDENTAL, ARISING OUT OF OR RELATING
      TO THE CONDUCT OF YOU OR ANYONE ELSE IN CONNECTION WITH THE USE OF THE
      SERVICES, INCLUDING WITHOUT LIMITATION, BODILY INJURY, EMOTIONAL DISTRESS,
      AND/OR ANY OTHER DAMAGES RESULTING FROM COMMUNICATIONS OR MEETINGS WITH
      OTHER REGISTERED USERS OF THE SERVICES. THIS INCLUDES ANY CLAIMS, LOSSES
      OR DAMAGES ARISING FROM THE CONDUCT OF USERS WHO HAVE REGISTERED UNDER
      FALSE PRETENSES OR WHO ATTEMPT TO DEFRAUD OR HARM YOU.
    </Text>
    <Text mb="3">
      3. Information Verification. Wave Snippets and its contractors may use
      various ways of verifying information that users have provided. However,
      none of those ways are perfect, and you agree that Wave Snippets and its
      contractors will have no liability to you arising from any incorrectly
      verified information.
    </Text>
    <Heading mb="4">Indemnification</Heading>
    <Text mb="3">
      You agree to indemnify, defend and hold harmless Wave Snippets, its
      officers, directors, employees, agents and third parties, for any losses,
      costs, liabilities and expenses (including reasonable attorneys’ fees)
      relating to or arising out of (a) your use of or inability to use the Site
      or Services, (b) any user postings made by you, (c) your violation of any
      terms of this Agreement or your violation of any rights of a third party,
      or (d) your violation of any applicable laws, rules or regulations. Wave
      Snippets reserves the right, at its own cost, to assume the exclusive
      defense and control of any matter otherwise subject to indemnification by
      you, in which event you will fully cooperate with Wave Snippets in
      asserting any available defenses.
    </Text>
    <Heading mb="4">Complaints / Law Enforcement Contact</Heading>
    <Text mb="3">
      To resolve a complaint regarding the Service, you e-mail us at
      wavesnippets@gmail.com
    </Text>
    <Text mb="3">
      Notice For California Users : Under California Civil Code Section 1789.3,
      California website users are entitled to know that they may file
      grievances and complaints with: the Complaint Assistance Unit of the
      Division of Consumer Services of the California Department of Consumer
      Affairs , in writing at 400 R Street, Suite 1080, Sacramento, California,
      95814, or by telephone at (916) 445-1254 or (800) 952-5210, or by email at
      dca@dca.ca.gov.
    </Text>
    <Heading mb="4">Typographical Errors</Heading>
    <Text mb="3">
      The System and the Services could include technical inaccuracies or
      typographical errors. Wave Snippets shall have no liability in connection
      with any such inaccuracies or errors, nor shall Wave Snippets have any
      obligation to identify and/or correct any such inaccuracies or errors.
    </Text>
    <Heading mb="4">Disclaimer of Third Party Information</Heading>
    <Text mb="3">
      To the extent that any information, material, or functionality on the
      System and Services is provided by third party content providers ("Third
      Party Materials"), Wave Snippets has no editorial control or
      responsibility over such Third Party Materials. Therefore, any opinions,
      statements, products, services or other Third Party Materials are those of
      the applicable third party. Wave Snippets does not represent or endorse
      the accuracy or reliability of any opinion, statement or other information
      provided by any third party (including any Submissions), or represent or
      warrant that your use of any Third Party Materials will not infringe
      rights of third parties not owned by or affiliated with Wave Snippets.
    </Text>
    <Heading mb="4">Delivery and Quality</Heading>
    <Text mb="3">
      Wave Snippets will use commercially reasonable efforts to ensure your
      exported snippets are delivered to you, but makes no guarantees to
      deliverability or the quality of the snippets. Creating snippets of this
      quality within the web is an experimental and ongoing effort that will
      likely change over time.
    </Text>
    <Heading mb="4">Data Persistance</Heading>
    <Text mb="3">
      Wave Snippets is an environment to create animated code snippets of your
      source code. To do that your code is persisted into a database and
      rendered onto servers in order to produce high quality snippets.{' '}
      <b>
        Please do not create snippets that contain proprietary source code
        because all snippets uploaded can be found via unlisted links.
      </b>{' '}
      Thought it is unlikely to be found without looking for them, it is
      recommended to only create snippets of code you are going to share
      publically. Wave Snippets persists snippets in our database and, if
      created anonymously, we will not be able to delete them as we won't know
      what snippet you created. We also store the exported filed from the
      exported snippets in the Google Compute Cloud and may delete them at any
      time. We reserve the right to move the location they are hosted at any
      time without notice. Wave Snippets assumes no liability for proprietary
      information being uploaded to any services.
    </Text>
    <Text mb="3">
      Wave Snippets allows you to create both public and unlisted snippets. All
      snippets, the exports, and source code contain therein are licensed under
      MIT license and requires no attribution should other users want to like or
      share them. Wave Snippets wants to create an open community of snippets to
      learn from, but it is encouraged as a user of the service to provide
      attribution if sharing snippets. Should Wave Snippets introduce private
      snippet functionality, private snippets will be unlicensed where you own
      all copyrights to the code (provided you have the rights to the code) and
      can license as you please.
    </Text>
    <Heading mb="4">Links to Other Websites or Services</Heading>
    <Text mb="3">
      Links to Other Websites For your convenience, certain hyperlinks may be
      provided on the System and Services that link to other websites or social
      media platforms which are not under the control of Wave Snippets (the
      "Linked Websites"). Wave Snippets does not endorse or sponsor any Linked
      Websites and is not responsible for the availability, accuracy, content,
      or any other aspect of the Linked Websites.
    </Text>
    <Text mb="3">
      There are places in the website, blog, application, or other places where
      we place affiliate links for other services and applications. We may be
      compensated if you click through those links, sign up for an account,
      interact with their service, or make a purchase on their site. Any
      affiliate links are governed by the same terms and conditions set forth
      herein.
    </Text>
    <Text mb="3">
      Wave Snippets disclaims all liability for such websites, for all access to
      and use thereof, and for use of the links to such websites. We also
      disclaim all liability, and make no representations or warranties, with
      respect to any products or services made available, sold, or provided to
      you by any third party. Your use of Linked Websites and any purchases of
      products or services from such Linked Websites are subject to the terms
      and conditions of such other websites. You agree that you will bring no
      suit or claim against Wave Snippets arising from or based upon any such
      use of any Linked Websites. Hyperlinks to such Linked Websites on the
      System and Services do not imply that: (a) Wave Snippets is affiliated or
      associated with any Linked Website; (b) Wave Snippets is legally
      authorized to use any trademark, trade name, logo, or copyright symbol
      displayed in connection with or accessible through such links; or (c) any
      Linked Site is authorized to use any trademark, trade name, logo, or
      copyright symbol of Wave Snippets.
    </Text>
    <Heading mb="4">Communication and Privacy</Heading>
    <Text mb="3">
      We may use your email address to send you messages notifying you of
      important changes to the Services or special offers.
    </Text>
    <Heading mb="4">Open Source</Heading>
    <Text mb="3">
      In the event Wave Snippets distributes any open source software to you as
      part of the Services (for example Linux, OpenStack, and software licensed
      under the Apache, GPL, MIT or other open source licenses, collectively
      “Open Source Software") then such Open Source Software is subject to the
      terms of the applicable open source license. To the extent there is a
      conflict with these Terms of Service, the terms of the applicable open
      source license shall control.
    </Text>
    <Heading mb="4">Publicity, Use of Marks</Heading>
    <Text mb="3">
      Unless otherwise agreed in the Service Order, you agree that Wave Snippets
      may publicly disclose that it is providing Services to you and may use
      your name and logo to identify you in promotional materials, including
      press releases. You may not issue any press release or publicity regarding
      the Agreement, use the Wave Snippets name or logo or other identifying
      indicia, or publicly disclose that it is using the Services without Wave
      Snippets’s prior written consent.
    </Text>
    <Heading mb="4">Assignment/Subcontractors</Heading>
    <Text mb="3">
      Wave Snippets may use its Affiliates or subcontractors to perform all or
      any part of the Services, but Wave Snippets remains responsible under the
      Agreement for work performed by its Affiliates and subcontractors to the
      same extent as if Wave Snippets performed the Services itself. You
      acknowledge and agree that Wave Snippets Affiliates and subcontractors may
      be based outside of the geographic jurisdiction in which you have chosen
      to store Customer Data and if legally required the parties will enter into
      good faith negotiations of such agreements as are necessary in order to
      legitimize the transfer of Customer Data.
    </Text>
    <Heading mb="4">General Provisions</Heading>
    <Text mb="3">
      1. Controlling Law and Jurisdiction. You agree that Delaware law (without
      giving effect to its conflicts of law principles) will govern this
      Agreement, the Site and the Services and that any dispute arising out of
      or relating to this Agreement, the Site or the Services will be subject to
      the exclusive jurisdiction and venue of the federal and state courts in
      Delaware. You acknowledge and agree that any violation of this Agreement
      may cause Wave Snippets irreparable harm, and therefore agree that Wave
      Snippets will be entitled to seek extraordinary relief in court, including
      but not limited to temporary restraining orders, preliminary injunctions
      and permanent injunctions without the necessity of posting a bond or other
      security, in addition to and without prejudice to any other rights or
      remedies that Wave Snippets may have for a breach of this Agreement.
    </Text>
    <Text mb="3">
      2. Miscellaneous. This Agreement, which you accept upon registration for
      the Services, the Privacy Statement located on the Site, and any
      applicable payment, renewal, Additional Services terms, comprise the
      entire agreement between you and Wave Snippets regarding the use of this
      Service, superseding any prior agreements between you and Wave Snippets
      related to your use of this Site or Services (including, but not limited
      to, any prior versions of this Agreement). The FAQ’s found on the Services
      are for informational purposes only and are not deemed to be part of this
      Agreement. Unless otherwise explicitly stated, the Agreement will survive
      termination of your registration to the Service. The failure of Wave
      Snippets to exercise or enforce any right or provision of this Agreement
      does not constitute a waiver of such right or provision. If any provision
      of this Agreement is held invalid, the remainder of this Agreement will
      continue in full force and effect. Regardless of any statute or law to the
      contrary, any claim or cause of action arising out of or related to the
      use of the Site or this Agreement must be filed within one (1) year after
      such claim or cause of action arose or be forever barred. The section
      titles in this Agreement are for convenience only and have no legal or
      contractual effect.
    </Text>
    <Heading mb="4">
      Special Provisions Applicable to Users Outside the United States
    </Heading>
    <Text mb="3">
      We strive to create a global community with consistent standards for
      everyone, but we also strive to respect local laws. The following
      provisions apply to Users and non-Users who interact with Wave Snippets
      outside the United States:
    </Text>
    <Text mb="3">
      (a) You consent to having your personal data transferred to and processed
      in the United States.
    </Text>
    <Text mb="3">
      (b) If you are located in a country embargoed by the United States, or are
      on the U.S. Treasury Department’s list of Specially Designated Nationals
      you will not engage in commercial activities on Wave Snippets (such as
      payments). You will not use Wave Snippets if you are prohibited from
      receiving products, services, or software originating from the United
      States.
    </Text>
    <Text mb="3">
      This policy is effective as of <b>8 July 2020</b>.
    </Text>
  </Page>
)
